import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sanityClient } from "../lib/sanityClient";
import { Helmet } from "react-helmet-async";
import { PortableText } from "@portabletext/react";

const ArticleDetailsPage = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const query = `*[_type == "article" && slug.current == $slug][0]`;
        const fetchedArticle = await sanityClient.fetch(query, { slug });
        setArticle(fetchedArticle);
      } catch (error) {
        console.error("Error fetching article:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [slug]);

  if (loading) return <p>Loading...</p>;
  if (!article) return <p>Article not found.</p>;

  const components = {
    types: {
      image: ({ value }) => <img src={value.asset.url} alt={value.alt || "Article image"} className="w-full rounded-lg" />,
    },
    marks: {
      link: ({ children, value }) => (
        <a href={value.href} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
          {children}
        </a>
      ),
    },
    block: {
      h1: ({ children }) => <h1 className="text-3xl font-bold">{children}</h1>,
      h2: ({ children }) => <h2 className="text-2xl font-semibold">{children}</h2>,
      normal: ({ children }) => <p className="text-lg">{children}</p>,
    },
  };

  return (
    <div className="container mx-auto p-6">
      <Helmet>
        <title>{article.title} - 237Mechanic</title>
        <meta name="description" content={article.description || article.title} />
      </Helmet>
      <h1 className="text-3xl font-bold mb-4">{article.title}</h1>
      <p className="text-gray-500">By {article.author} | {new Date(article.publishedAt).toDateString()}</p>
      {article.primaryImage && (
        <img
          src={article.primaryImage}
          alt={article.title}
          className="w-full h-80 object-cover my-4 rounded-lg"
        />
      )}
      <div className="prose max-w-full">
        <PortableText value={article.content} components={components} />
      </div>
      {article.additionalImages && article.additionalImages.length > 0 && (
        <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-4">
          {article.additionalImages.map((img, index) => (
            <img key={index} src={img} alt="Additional" className="rounded-lg" />
          ))}
        </div>
      )}
    </div>
  );
};

export default ArticleDetailsPage;
